<section class="page">
  <header class="page-header">
    <h2>Fichiers en attente d'analyse</h2>
    <p class="subtitle">Fichiers importés qui n'ont encore fait l'objet d'aucune analyse.</p>
  </header>

  <section class="panel">
    <div class="actions-row">
      <button type="button" (click)="refresh()" [disabled]="loading">
        {{ loading ? 'Chargement...' : 'Actualiser la liste' }}
      </button>
      <a class="action-link" routerLink="/intranet/gestion-pipe/consulter-antagene">Lancer les analyses</a>
    </div>

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des fichiers importés...</p>
    } @else if (items.length === 0) {
      <p class="meta">Aucun fichier en attente d'analyse.</p>
    } @else {
      <p class="meta">{{ items.length }} fichier(s) en attente d'analyse.</p>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Nom</th>
              <th>Cartouches</th>
              <th>Date import</th>
              <th>Taille</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.name) {
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.cartouches || '-' }}</td>
                <td>{{ formatDate(item.date_import) || '-' }}</td>
                <td>{{ item.size }} octets</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</section>